import { Button, Input, Select, Space, Switch } from "antd";
import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { LogEvents, LoggerContext } from "../../../../context/logging";

export const ProductFinder = ({
  search,
  setSearch,
  vendorID,
  setVendorID,
  categoryID,
  setCategoryID,
  viewOrganisationProducts,
  setViewOrganisationProducts,
  addProduct,
  page,
  setPage,
  onSubmit,
}) => {
  const [categories, setCategories] = React.useState([]);
  const [brands, setBrands] = React.useState([]);

  const logger = React.useContext(LoggerContext);

  React.useEffect(() => {
    // fetchCategories();
    fetchBrands();
  }, []);

  const fetchCategories = () => {
    axios
      .get(`mdV1/categories/`)
      .then((res) => {
        setCategories(res.data);
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      });
  };

  const fetchBrands = () => {
    axios
      .get(`mdV1/brands/`)
      .then((res) => {
        setBrands(res.data);
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      });
  };

  const categoryOptions = categories?.map((each) => (
    <Select.Option key={each?._id?.$oid} value={each?.title}>
      {each?.title}
    </Select.Option>
  ));

  const brandOptions = brands?.map((each) => (
    <Select.Option key={each?._id?.$oid} value={each?.name}>
      {each?.name}
    </Select.Option>
  ));

  return (
    <form onSubmit={onSubmit}>
      <Space>
        <Input
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Select
          allowClear
          size="middle"
          showSearch
          values={categoryID}
          onChange={(e) => {
            setCategoryID(e);
          }}
          placeholder="Categories"
          filterOption={(input, option) =>
            option.children
              ?.toLowerCase()
              .indexOf(input?.toLowerCase()) >= 0
          }
          style={{ width: 200 }}
        >
          {categoryOptions}
        </Select>
        <Select
          allowClear
          size="middle"
          showSearch
          onChange={(e) => {
            setVendorID(e);
          }}
          values={vendorID}
          placeholder="Brands"
          filterOption={(input, option) =>
            option.children
              ?.toLowerCase()
              .indexOf(input?.toLowerCase()) >= 0
          }
          style={{ width: 200 }}
        >
          {brandOptions}
        </Select>
        <Button type="primary" htmlType="submit">
          Search
        </Button>
        <Link to={'/app/ecommerce/wishlist'}>
          <Button
            type="default"
          >
            View Wishlist
          </Button>
        </Link>
        <Button
          onClick={addProduct}
        >
          Add product
        </Button>
        <Switch
          checked={viewOrganisationProducts}
          onChange={(value) => {
            setViewOrganisationProducts(value);
            if (value) {
              logger.log(LogEvents.viewOrganisationProducts);
            }
          }}
        />
        <span
        >
          View Organisation Products
        </span>
      </Space>
    </form>
  )
};
